import { color, spaces } from "emoreg/const";
import { rem } from "polished";
import styled from "styled-components";

const Container = styled.div<{ disabled?: boolean; hasError?: boolean }>(
  {
    display: "inline-block",
    position: "relative",
    height: spaces[16],
    width: spaces[16],
    // prevent unexpected compression
    minHeight: spaces[16],
    minWidth: spaces[16],
    backgroundColor: "white",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: "50%",
    pointerEvents: "none",

    "&:before": {
      content: "''",
      position: "absolute",
      backgroundColor: "white",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      height: rem(6),
      width: rem(6),
      borderRadius: "50%",
    },

    // only use css feature to detect if input is checked
    // allowing uncontrolled component to work as well
    // as controlled components
    "&:has(input:checked:not(:disabled))": {
      backgroundColor: color.blue.base,
    },

    "&:has(input:checked:disabled)": {
      backgroundColor: color.grey.base,
      "&:before": { backgroundColor: color.grey.light },
    },

    "&:has(input:not(checked):disabled)": {
      backgroundColor: color.grey.light,
      "&:before": { backgroundColor: color.grey.light },
    },
  },
  ({ disabled, hasError }) => {
    if (disabled) return { borderColor: color.grey.base };
    if (hasError) return { borderColor: color.red.base };
    return { borderColor: color.grey.base };
  }
);

Container.baseName = "RadioInputContainer";

const Input = styled.input({
  position: "absolute",
  inset: 0,
  pointerEvents: "all",
  cursor: "pointer",
  opacity: 0,
  "&:disabled": {
    cursor: "not-allowed",
  },
});

Input.baseName = "RadioInput";

export const RadioInputStyle = Object.assign(Container, { Input });
